
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support-us",
      function () {
        return require("private-next-pages/support-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support-us"])
      });
    }
  